import { Stack, Box, IconSubCategory } from 'braid-design-system';

import { OptionsButton } from 'src/components/atoms/Buttons';
import ThreadContent from 'src/components/atoms/ThreadContent/ThreadContent';
import ThreadPersonalDetails from 'src/components/atoms/ThreadPersonalDetails/ThreadPersonalDetails';
import type { Reply } from 'src/mapper/threadMapper';

interface CommentReplyCardProps {
  reply: Reply;
}

export default ({ reply }: CommentReplyCardProps) => {
  const content = reply.content;
  const postingDate = reply.creationDate;

  return (
    <Box
      display="flex"
      flexDirection="row"
      paddingBottom="xsmall"
      width="full"
      paddingLeft="small"
    >
      <Box paddingTop="small">
        <IconSubCategory size="standard" tone="secondary" />
      </Box>
      <Box width="full" paddingLeft="small">
        <Stack space="xsmall">
          <Box
            display="flex"
            justifyContent="spaceBetween"
            paddingTop="small"
            width="full"
          >
            <ThreadPersonalDetails
              author={reply.author}
              postingDate={postingDate}
            />
            <OptionsButton />
          </Box>
          <ThreadContent text={content} />
        </Stack>
      </Box>
    </Box>
  );
};
